import { toast } from '@/components/toast';
import { deleteTranslation } from '@/services/api';
import { logger } from '@/services/logger';
import { useMutation, useQueryClient } from 'react-query';
import { GET_TRANSLATIONS_KEY } from './translationLibrary';

export const useDeleteTranslation = (skipToast?: boolean) => {
    const queryClient = useQueryClient();

    return useMutation(deleteTranslation, {
        onError: async (err: any, id) => {
            if (err.response.status !== 404) {
                logger.error(`Could not delete translation: ${id}`, { err });
                if (!skipToast) {
                    toast.error({ title: `Could not delete video`, toastId: `library-item-delete-error` });
                }
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries(GET_TRANSLATIONS_KEY);
            if (!skipToast) {
                toast.success({ title: 'Your video was successfully deleted' });
            }
        },
    });
};
